var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "block",
    { staticStyle: { "padding-bottom": "60px" } },
    [
      _c("template", { slot: "header" }, [
        _c("span", { staticStyle: { color: "#449D7A" } }, [
          _vm._v("Atención finalizada exitosamente")
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("p", { staticClass: "question" }, [
          _vm._v("¿Desea agregar una nueva atención para el estudiante?")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "action" }, [
          _c(
            "button",
            {
              staticClass: "button is-primary",
              on: {
                click: function($event) {
                  return _vm.navigateTo("app.profile.add_attention")
                }
              }
            },
            [_vm._v("\n        Sí, agendar atención\n      ")]
          ),
          _vm._v("\n       \n      "),
          _c(
            "button",
            {
              staticClass: "button",
              on: {
                click: function($event) {
                  return _vm.navigateTo("app.profile.attentions")
                }
              }
            },
            [_vm._v("No, volver")]
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }